<template>
  <div class="form">
    <Loading
      v-if="loadingSaveData"
      class="mb-2"
    />

    <div class="form-group">
      <label for="name">{{$t('admin.additional_works.form.zagolovok')}}</label>
      <div class="flex items-center">
        <input
          id="name"
          type="text"
          v-model="form.name"
        />
      </div>
      <ValidationErrors :errors="errorsFor('name')" />
    </div>
    <div class="form-group">
      <label for="name">{{$t('admin.additional_works.form.short_description')}}</label>
      <div class="flex items-center">
        <textarea v-model="form.description"></textarea>
      </div>
      <ValidationErrors :errors="errorsFor('description')" />
    </div>
    <div class="form-group">
      <label for="price">{{$t('admin.additional_works.form.cena_rub')}}</label>
      <div class="flex items-center">
        <input
          id="price"
          type="text"
          v-model="form.price"
        />
      </div>
      <ValidationErrors :errors="errorsFor('price')" />
    </div>

    <div class="form-group">
      <label for="cost">{{$t('main.label_cost_price_currency')}}</label>
      <div class="flex items-center">
        <input
          id="cost"
          type="text"
          v-model="form.cost"
        />
      </div>
      <ValidationErrors :errors="errorsFor('cost')" />
    </div>

    <div class="form-group">
      <div class="flex items-center">
        <label for="image">{{$t('admin.additional_works.form.image')}} </label>
      </div>
      <FileInputBlock
        :prefill="imagePreview"
        :selectedImageFileNameDefault="$t('admin.additional_works.form.image_texture_not_selected')"
        @selected-file="(file) => selectFile(file, 'selectedImage')"
      >
        <ValidationErrors :errors="errorsFor('image')" />
      </FileInputBlock>
    </div>

    <div class="form-group">
      <button
        @click="saveData"
        class="btn btn-small btn-green"
      >
        {{$t('admin.additional_works.form.save')}}
      </button>
    </div>
  </div>
</template>

<script>
import validationErrors from "../../../mixins/validationErrors";

export default {
  name: "Form",
  mixins: [validationErrors],
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imagePreview: null,
      loadingSaveData: false,
      form: {
        name: null,
        description: null,
        price: null,
        cost: null,
        selectedImage: null,
      },
    };
  },
  created() {},
  methods: {
    selectFile(file, dataProps) {
      this.form[dataProps] = file;
    },
    async saveData() {
      this.errors = null;
      this.loadingSaveData = true;

      try {
        let formDataPost = new FormData();

        if (this.formData.work) formDataPost.append("_method", "PATCH");

        if (this.form.name !== null) {
          formDataPost.append("name", this.form.name);
        }

        if (this.form.description !== null) {
          formDataPost.append("description", this.form.description);
        }

        if (this.form.price !== null) {
          formDataPost.append("price", this.form.price);
        }

        if (this.form.cost !== null) {
          formDataPost.append("cost", this.form.cost);
        }

        if (this.formData.type !== null) {
          formDataPost.append("type", this.formData.type);
        }

        if (this.formData.element_group !== null) {
          formDataPost.append("element_group", this.formData.element_group);
        }

        if (this.form.selectedImage !== null) {
          formDataPost.append("image", this.form.selectedImage);
        }

        let url = "/api/admin/additional_works";
        if (this.formData.work)
          url = `/api/admin/additional_works/${this.formData.work.additional_work_id}`;

        const res = (
          await axios.post(url, formDataPost, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;

        const notification = {
          type: "success",
          message: "Добавление прошло успешно",
        };
        this.$store.dispatch("notification/add", notification, { root: true });
        this.$emit("additional-work-saved");
      } catch (error) {
        this.errors = error.response && error.response.data.errors;
        this.status = error.response && error.response.status;
        if (!error.response) console.log(error);
      }
      this.loadingSaveData = false;
    },
  },
};
</script>

